export default {
  methods: {
    textoAcreditacion(
      tipoInstitucion,
      acreditado,
      anios,
      observacionAcreditacionCNA
    ) {
      if (acreditado) {
        if (acreditado && anios === 0) {
          if (tipoInstitucion === "TECNICO_PROFESIONAL") {
            return "Acreditado";
          } else {
            return "Acreditada";
          }
        } else {
          return `Acreditación Institucional ${anios} ${
            anios > 1 ? "años" : "año"
          }`;
        }
      } else if (observacionAcreditacionCNA) {
        return "Bajo Tutela";
      } else {
        if (tipoInstitucion === "TECNICO_PROFESIONAL") {
          return "No Acreditado";
        } else {
          return "No Acreditada";
        }
      }
    },
    getBase64Image(logo) {
      if (logo) {
        return "data:image/png;base64," + logo;
      } else {
        return "EnBlanco";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/iconosInstituciones.js